<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    <button class="returnBtn" @click="back">返回</button>
     <div class="mt-1 container font">
     <p v-show="error">{{ error }}</p>   
   
         <div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="topTitle">笔记列表</div>

          <div>
              <div v-if="account!=undefined && account.user_info !=undefined" class="d-flex justify-content align-items-center">
                  <div v-if="account.user_info.imageb!=undefined">
                    <img :src="account.user_info.imageb" class="account_icon">
                  </div>
                  <div class="d-flex flex-row align-items-center">
                      <div>{{account.user_info.nickname}}</div>
                  </div>
            </div>

          </div>
        </div>


        <div class="mt-1 d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content">
            <div class="topTitle">排序:</div>

            <div class="d-flex justify-content align-items-center"  >
              <span class="btn ml-2" :class="order_type=='createdAt'?'btn-primary':' btn-secondary'" @click="setOrder('createdAt')">日期</span>
              <span class="btn ml-1" :class="order_type=='view_count'?'btn-primary':' btn-secondary'" @click="setOrder('view_count')">观看</span>
              <span class="btn ml-1" :class="order_type=='likes'?'btn-primary':' btn-secondary'" @click="setOrder('likes')">点赞</span>
              <span class="btn ml-1" :class="order_type=='collected_count'?'btn-primary':' btn-secondary'" @click="setOrder('collected_count')">收藏</span>
              <span class="btn ml-1" :class="order_type=='comments_count'?'btn-primary':' btn-secondary'" @click="setOrder('comments_count')">评论</span>
              <span class="btn ml-1" :class="order_type=='shared_count'?'btn-primary':' btn-secondary'" @click="setOrder('shared_count')">转发</span>
            </div>
          </div>

            <div class="btnAdd" @click="newNote"><img src="../assets/icon-edit.png">新增笔记</div>
             
          </div>

        <div class="row d-flex justify-content-center">
          <div v-if="notes.length==0" class="m-1">暂无笔记</div>

          

          <div v-for="(note, index) in notes" :key="index" class="mt-1 card col-auto m-1">
          
            <div>
              <div>
                      <img :src="note.cover" class="img" v-if="note.cover!=undefined && note.cover!=''">
                      <div v-else>
                        <img :src="note.imgs[0]" class="img" v-if="note.imgs!=undefined && note.imgs.length>0">
                      </div>    
               </div>
                  <div v-if="note.video!=undefined">
                      <a  :href="note.video" target="blank">视频</a>
                    </div>
              
               <div class="cardText p-1 d-flex flex-column justify-content-evenly">
                <div>{{ note.title}}
                  <span v-if="note.cancel==true" class="error-message">[取消发布]</span>
                  <span v-if="note.sent!=true" class="error-message">[未发布]</span></div>
                  <div class="d-flex flex-row align-items-center" v-if="note.user_info!=undefined">
                      <div>{{note.user_info.nickname}}</div>
                  </div>
                <div>生成日期：{{ localDatetime(note.createdDate) }}</div>
                <div v-if="note.publish_time!=undefined">发送日期：{{ note.publish_time }}</div>
                <div class="d-flex justify-content-between mt-1">
                  <router-link :to="`/index/user/detail/${note.objectId}`">
                    <div  class="backBtn mr-1">查看</div>
                  </router-link>

                 
                  <a :href="`https://www.xiaohongshu.com/explore/${note.hot.xhs_id}?xsec_token=${note.hot.xsec_token}&xsec_source=pc_feed`" target="blank" v-if="note.hot!=undefined&&note.hot.xhs_id !== undefined &&note.hot.xsec_token!=undefined ">小红书原帖</a>
                   <div class="backBtn ml-1" @click="deleteItem(index)" v-if="note.url==undefined && note.cancel!=true">取消发布</div>
                 
                </div>
               

                <div  v-if="note.count!=undefined">
                <div class="d-flex justify-content-between mt-1">
                  <div v-if="note.count.view_count!=undefined" class="d-flex align-items-center">
                    <img src="../assets/view_icon.png" class="icon"><span>{{ note.count.view_count }}</span>
                    <img src="../assets/fire.png" v-if="note.count.view_count>10000" class="icon">
                  </div>

                  <div v-if="note.count.likes!=undefined" class="d-flex align-items-center">
                    <img src="../assets/like_icon.png" class="icon"><span>{{ note.count.likes }}</span>
                    <img src="../assets/fire.png" v-if="note.count.likes>100" class="icon">
                  </div>

                  <div v-if="note.count.collected_count!=undefined" class="d-flex align-items-center">
                    <img src="../assets/collect_icon.png" class="icon"><span>{{ note.count.collected_count }}</span>
                    <img src="../assets/fire.png" v-if="note.count.collected_count>100" class="icon">
                  </div>

                  <div v-if="note.count.shared_count!=undefined" class="d-flex align-items-center">
                    <img src="../assets/resend_icon.png" class="icon"><span>{{ note.count.shared_count }}</span>
                    <img src="../assets/fire.png" v-if="note.count.shared_count>100" class="icon">
                  </div>

                  <div v-if="note.count.comments_count!=undefined" class="d-flex align-items-center">
                    <img src="../assets/comment_icon.png" class="icon"><span>{{ note.count.comments_count }}</span>
                    <img src="../assets/fire.png" v-if="note.count.comments_count>50" class="icon">
                  </div>
                </div>
                <div class="mb-1 secondColor">数据: {{ formatDate(note.count.collect_time) }}</div>
               <div>
              </div>
               </div>

               <div class="d-flex justify-content-end mt-1"  v-if="isAdmin">
                    <div  class="backBtn mr-1" @click="deleteSucai(index)" >删除对应素材</div>
                    <div  class="backBtn mr-1" @click="wrongImg(index)" >照片有误</div>

                    <div  class="backBtn mr-1" @click="invalidSeries(index)">系列无效</div>
               </div>

               <div class="d-flex justify-content-end mt-1"  v-if="isAdmin">
                    <div  class="backBtn mr-1" @click="sendNote(index)" >重新发送笔记</div>

                    <div  class="backBtn mr-1" @click="hideNote(index)" v-if="note.url!=undefined && note.url!='' && !note.hide">隐藏笔记</div>
               </div>
               

               </div>
              
            </div>
       
              
              
               
               
            
              
              </div>
        </div>


        <div class="mt-1 pb-1 d-flex justify-content" v-if="totalPage>0&&isLoading==false">
          <div v-for="(n,index) in totalPage" :key="index">
            <div :class="n==page?'pageBox mr-1 selectedPageBox':'pageBox mr-1 normalPage'" @click="changePage(n)">
              {{ n }}
            </div>
            
          </div>

        </div>
            
    
         </div>
   
      
     </div>

     
   </template>
   
   <script>
   
   import GridLoader from 'vue-spinner/src/GridLoader.vue'
   import axios from 'axios';
   import moment from 'moment';
 
   
   export default {
     data(){
       return {
         isLoading:false,
         keyword:'',
         error:'',
         accountId:'',
         account:null,
         notes:[],
         spinnerColor:"#262626",
         text:'test\ntest',
         page:1,
         count:10,
         totalPage:1,
         selectedNoteId:null,
         isView:false,
         isAdmin:false,
         order_type:'createdAt',
         sending:false,
         userId:null,
         groupId:null

       }
       
     },
     computed: {
     localDatetime() {
       return (datetimeString) => {
         let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD HH:mm:ss');
         return beijingTime
         
       }
     },
     
     formatDate(){
      return (datetimeString) => {
        console.log(datetimeString)
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD HH:mm:ss');
         return beijingTime
         
       }
     }
   },
   
     components: {
      GridLoader,

     },
      setup(){
        var token=localStorage.getItem('sessionToken')
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
     },
   
   
     mounted(){
      

      var token=localStorage.getItem('sessionToken')
       
          if(token==undefined || token==null ||token=='')
        {
          this.$router.push('/')
          return
        }
        var role=localStorage.getItem('role')
        if(role!=undefined && role>0)
        {
          this.isAdmin=true
        }
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
        var current = this.$route.path;
        console.log(current.includes('usernotes'))

        if(current.includes('usernotes'))
        {
          if(current.includes('admin'))
          {
            this.userId=this.$route.params.id;
            this.groupId=this.$route.params.g_id;
            console.log(this.groupId)
          }
          
        }
        else
        {
          
          this.accountId = this.$route.params.id;
        }
      

       this.getAccounts()
       this.getPages()
       this.getNotes()
     },
     methods:{

      newNote(){
       
          this.$router.push('/index/user/newn/'+this.accountId)
        
        
      },

      setOrder(order){
        if(this.order_type==order)
        {
          return
        }
        this.order_type=order;
        this.getNotes()
      },
     async deleteItem(index){
        this.isLoading=true;
        try{
          var note=this.notes[index]
          const response = await axios.get(this.domain+'xhs/cancel_send_note?note_id='+note.objectId);

          var data=response.data
          if(data.status=='Suc')
          {

            this.notes[index]['cancel']=true;
          }
          else
          {
              console.error(data)
              
          }
      }
      catch(error)
      {
          console.error(data)
      }
      finally{
        this.isLoading=false
      }

        

      },

     async hideNote(index){
          this.isLoading=true;
            try{
              var note=this.notes[index]
              const response = await axios.get(this.domain+'xhs/hide_note?note_id='+note.objectId);

              var data=response.data
              if(data.status=='Suc')
              {
                this.notes[index]['hide']=0;
              }
              else
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally{
            this.isLoading=false
          }

      },

      async sendNote(index){
          this.isLoading=true;
          this.sending=true;
            try{
              var note=this.notes[index]
              const response = await axios.get(this.domain+'xhs/resend_note?note_id='+note.objectId);

              var data=response.data
              if(data.status=='Suc')
              {
                this.sending=false;
                this.notes[index]['url']='empty';
              }
              else
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally{
            this.isLoading=false
          }

      },

      async deleteSucai(index){
          this.isLoading=true;
            try{
              var note=this.notes[index]
              const response = await axios.get(this.domain+'xhs/delete_sucai?note_id='+note.objectId);

              var data=response.data
              if(data.status=='Suc')
              {
                this.notes[index]['hide']=0;
              }
              else
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally{
            this.isLoading=false
          }

      },

      async wrongImg(index){
          this.isLoading=true;
            try{
              var note=this.notes[index]
              const response = await axios.get(this.domain+'xhs/wrong_img?note_id='+note.objectId);

              var data=response.data
              if(data.status=='Suc')
              {
                this.notes[index]['hide']=false;
              }
              else
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally{
            this.isLoading=false
          }

      },


      async invalidSeries(index){
          this.isLoading=true;
            try{
              var note=this.notes[index]
              const response = await axios.get(this.domain+'xhs/invalid_series?note_id='+note.objectId);

              var data=response.data
              if(data.status=='Suc')
              {
                this.notes[index]['hide']=0;
              }
              else
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally{
            this.isLoading=false
          }

      },

      back(){
        this.$router.go(-1)
      },
      viewDetail(note_id){
        this.selectedNoteId=note_id
        this.isView=true;

      },
       async getAccounts(){
         try{

          console.log(this.accountId)
            if(this.accountId==null || this.accountId=='')
            {
              return

            }
             const response = await axios.get(this.domain+'xhs/get_account_by_id?account_id='+this.accountId);

             var data=response.data
             if(data.status=='Suc')
             {

                 this.account=data['account']
             }
             else
             {
                 console.error(data)
                 
             }
         }
         catch(error)
         {
             console.error(data)
         }
       },
       async getPages(){
         try{
            this.isLoading=true
            console.log(this.userId)
           const response = await axios.get(this.domain+'xhs/get_notes_count?account_id='+this.accountId+'&user_id='+this.userId+'&group_id='+this.groupId);
          
           var data=response.data
           if(data['status']=='Suc')
           {

               var count=data['count']
               this.totalPage=Math.ceil(count/this.count)
               this.page=1
              
           }
           else
           {
               console.error(data)
               
           }
         }
         catch(error)
         {
             console.error(data)
         }
         finally{
          this.isLoading=false
         }
       },

       changePage(n){
        if(n==this.page)
        {
          return
        }
        this.page=n
        this.getNotes()
       },
        async getNotes(){
         try{
            this.isLoading=true
            console.log(this.groupId)
           const response = await axios.get(this.domain+'xhs/get_sent_notes?account_id='+this.accountId+'&user_id='+this.userId+'&group_id='+this.groupId+'&page='+this.page+'&count='+this.count+'&order='+this.order_type);
          
           var data=response.data
           if(data['status']=='Suc')
           {  
            console.log(data)
               this.notes=data['notes']
           }
           else
           {
               console.error(data)
               
           }
         }
         catch(error)
         {
             console.error(data)
         }
         finally{
          this.isLoading=false
         }
       },
     }
      
     
   };
   </script>
<style scoped>

.img{
    width:3.5rem;
    border-radius: 0.125rem, 0.125rem,0 0;
}

.card{
  height:max-content;
  min-width: 3rem;
  max-width: 4rem;
}

.cardText{
  color: #262626;
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 500;
 text-align: left;
}
.icon{
  width:0.175rem;
  height:0.175rem;
}

.account_icon{
  width:0.5rem;
  height:0.5rem;
  border-radius: 50%;
}


</style>
   